/** Desk studio page for a Glofox location id. `baseUrl` is the Desk origin. */
export function deskStudioUrl(baseUrl: string, branchId: string): string {
  const base = baseUrl.replace(/\/$/, "");
  return `${base}/desk/#/studios/${encodeURIComponent(branchId)}`;
}
